import * as React from 'react'
import { Sparkle } from '@phosphor-icons/react'
import { observer } from 'mobx-react-lite'
import { store } from 'store/index'
import { useIsActive } from 'app/packs/src/utils/use-is-active'
import { sideNavAnalyticsProps } from '../side-nav-analytics-props'
import * as SideMenu from 'components/side-menu'

export const FrameworkBuilderLink = observer(() => {
  const isAdmin = store.currentUser?.isAdmin

  if (!isAdmin) return null
  if (!store.featureFlags.featureEnabled('framework_builder')) return null

  const path = '/framework-builder'
  const title = 'Frameworks'

  return (
    <SideMenu.LinkItem
      active={useIsActive(path)}
      analyticsProps={sideNavAnalyticsProps({ href: path, title })}
      href={path}
      icon={Sparkle}
    >
      {title}
    </SideMenu.LinkItem>
  )
})
